import * as services from '../services'
import * as TYPES from './mutations-types'

export const attemptGetPartnersList = ({ commit }, pagination) => {
  return services.getPartnersList(pagination)
    .then(partnersList => {
      commit(TYPES.SET_PARTNERS_LIST, partnersList.data.data)

      return {
        data: partnersList.data.data,
        firstPage: partnersList.data.firstPage,
        lastPage: partnersList.data.lastPage,
        nextPage: partnersList.data.nextPage,
        previousPage: partnersList.data.previousPage,
        total: partnersList.data.total
      }
    })
}

export const attemptRemovePartner = (_, data) => {
  return services.removePartner(data)
    .then(response => {
      return response
    })
}

export const attemptToggleActivePartner = (_, idPartner) => {
  return services.toggleActivePartner(idPartner)
    .then(response => {
      return response
    })
}

export const attemptGetPartner = (_, partnerId) => {
  return services.getPartner(partnerId)
}

export const attemptCreatePartner = (_, payload) => {
  return services.createPartner(payload)
}

export const attemptUpdatePartner = (_, payload) => {
  return services.updatePartner(payload)
}
